/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { EnviarBoletoPorEmail } from './atom/EnviarBoletoPorEmail';
import { RenderizarBoleto } from './atom/RenderizarBoleto';
import mensalidadeService from '../../../services/mensalidades/mensalidadeService';
import {    
    somaValorTotalParcelas,
    makeParcelasString
} from '../../../modulos/mensalidade/utilsBoletoAdyen';
import { ProgressSpinner } from 'primereact/progressspinner';
import './dialog-pdf.css';

export default function DialogPdf({
    inscricao,
    open,
    setOpen,
    header,
    pdf,
    urlSemParse,
    setMetodoPagamento,
    faturas,
    loadingBoleto
}) {
    const [enviarBoleto, setEnviarBoleto] = useState(false);
    const [valorTotalFaturas, setValorTotalFaturas] = useState(0);
    const [parcelas, setParcelas] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const close = () => {
        setMetodoPagamento(null);
        setEnviarBoleto(false);
        setParcelas('');
        setValorTotalFaturas(0);
        setOpen(false);
        setLoading(true);
    };

    useEffect(() => {
        (async () => {
            setLoading(true);

            const stringParcelas = makeParcelasString(faturas);

            setParcelas(stringParcelas);

            const associadoEmail = await mensalidadeService.buscaAssociadoPorInscricao(
                inscricao
            );

            setEmail(associadoEmail.AssEmail);

            const valorSomaTodasFaturasSelecionadas = somaValorTotalParcelas(faturas);

            setValorTotalFaturas(valorSomaTodasFaturasSelecionadas);
            setLoading(false);
        })();
    }, [enviarBoleto]);

    return (
        <Dialog
            visible={open}
            onHide={close}
            className="dialog-boleto"
            position={'top'}
            header={header}
        >
            <div className="download-pdf">
                {enviarBoleto && (
                    <EnviarBoletoPorEmail
                        closeModal={close}
                        email={email}
                        setEmail={setEmail}
                        loading={loading}
                        setLoading={setLoading}
                        parcelas={parcelas}
                        valorTotalFaturas={valorTotalFaturas}
                        faturas={parcelas}
                        urlBoleto={urlSemParse}
                    />
                )}
                {loadingBoleto && <div className='separacao-dialog-pdf' >
                    <ProgressSpinner/>
                </div> } 
                {!enviarBoleto && !loadingBoleto && (
                    <RenderizarBoleto urlPdf={pdf} setEnviarBoleto={setEnviarBoleto}/>
                )}
            </div>
        </Dialog>
    );
}
